<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Órarend</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="kulsonezetmodal.present()" title="Helyettesítések külső nézete">
        <ion-icon slot="icon-only" name="open-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<!-- ══════════════════════════════════════════════════════════════════════════
     HELYETTESÍTÉSEK KÜLSŐ NÉZETE.
     A cím ide tartozik, nem a naptárhoz: a helyettesítés az órarend ügye.
     ══════════════════════════════════════════════════════════════════════════ -->
<ion-modal #kulsonezetmodal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start"><ion-button (click)="kulsonezetmodal.dismiss()">Bezár</ion-button></ion-buttons>
        <ion-title>Helyettesítések külső nézete</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-note color="medium" style="display:block;margin-bottom:14px">
        A helyettesítési lista beágyazható egy honlapba, SharePoint-oldalba vagy Teams-fülbe,
        és kitehető a tanáriban lévő kijelzőre. <b>Bejelentkezés nélkül</b> nyílik, ezért nem
        kell hozzá semmit beállítani a beágyazó oldalon.
      </ion-note>

      <div class="kn-blokk">
        <h3>A lista címe</h3>
        <p>A következő két hét helyettesítései, naponta csoportosítva, órarendi sorrendben.
           A mai napból csak az <b>esedékes</b> órák látszanak: ami már lezajlott, lekerül.</p>
        <div class="kn-cim">
          <code>{{ kulsoNezetCim() }}</code>
          <ion-button size="small" fill="outline" (click)="kulsoNezetMasol(kulsoNezetCim())">
            <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás
          </ion-button>
        </div>
      </div>

      <div class="kn-blokk">
        <h3>Saját órák kiemelése</h3>
        <p>Ha a beágyazó oldal hozzáfűzi a bejelentkezett felhasználó <b>e-mail címét</b>, a
           lista az ő sorait <b>kiemeli</b>, és a tetején megmondja, hány ilyen van. Két
           jelölés különbözteti meg őket: <b>„te helyettesítesz"</b> és <b>„a te órád"</b>.
           A lista ettől <b>nem szűkül</b> — mindenki tétele látszik, a kiemelés csak segítség.</p>
        <div class="kn-cim">
          <code>{{ kulsoNezetCim() }}?email=<i>a.felhasznalo&#64;cime.hu</i></code>
          <ion-button size="small" fill="outline" (click)="kulsoNezetMasol(kulsoNezetCim() + '?email=')">
            <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás
          </ion-button>
        </div>

        <p style="margin-top:12px">A cím helyére <b>változó</b> is írható, amit a beágyazó
           felület cserél le a bejelentkezett felhasználó címére. Teams-fülnél ilyen a
           <code>&#123;loginHint&#125;</code> (és a <code>&#123;userPrincipalName&#125;</code>):</p>
        <div class="kn-cim">
          <code>{{ kulsoNezetCim() }}?email=&#123;loginHint&#125;</code>
          <ion-button size="small" fill="outline"
                      (click)="kulsoNezetMasol(kulsoNezetCim() + '?email={loginHint}')">
            <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás
          </ion-button>
        </div>
        <ion-note color="medium" style="display:block;margin-top:8px">
          A behelyettesítést <b>nem mi végezzük</b>, hanem a beágyazó felület — és csak bizonyos
          fül-típusoknál teszi meg. Ha elmarad, a jelölő nyersen érkezik meg, és a lap ezt
          <b>ki is írja</b> („a cím változóként érkezett"), tehát nem kell találgatni.
          A vállalati felhasználónév (UPN) akkor is jó, ha a törzsadatban más cím szerepel:
          ilyenkor a <code>&#64;</code> előtti részt vetjük össze a dolgozói azonosítóval.
        </ion-note>
        <ion-note color="warning" style="display:block;margin-top:8px">
          <b>Vigyázz, melyik jelölőt másolod.</b> A SharePoint-os
          <code>&#123;user.userPrincipalName&#125;</code> alakot a <b>Teams nem cseréli le</b> —
          nyersen érkezik meg, és a naptár minden közzétett programot mutat. Teams-fülön
          <code>&#123;loginHint&#125;</code> kell.
        </ion-note>
        <ion-note color="medium" style="display:block;margin-top:8px">
          A <code>&#64;</code> nyersen és <code>%40</code>-ként kódolva is jó, a kis- és nagybetű
          nem számít, a paraméterek sorrendje pedig mindegy. Ismeretlen címnél a lista teljes
          marad, és kiírja, hogy nem talált hozzá munkatársat — így egy elgépelt cím vagy egy
          rosszul behelyettesített változó nem néma hiba.
        </ion-note>
      </div>

      <div class="kn-blokk">
        <h3>Időszak</h3>
        <p>Alapból mától <b>14 nap</b>. Ezen a <code>napok</code> (1–120) és a <code>tol</code>
           (ÉÉÉÉ-HH-NN) paraméterrel lehet változtatni. Az első paraméter elé <code>?</code>,
           a többi elé <code>&amp;</code> kerül:</p>
        <ul class="kn-peldak">
          <li><code>?napok=5</code></li>
          <li><code>?email=valaki&#64;zenit.hu&amp;napok=5</code></li>
          <li><code>?tol=2026-09-01&amp;napok=30&amp;email=valaki&#64;zenit.hu</code></li>
        </ul>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- ═══ NYOMTATÁS: a megjelenített hét, A4 fekvő lapon ═══ -->
<ion-modal #nyomtatasmodal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start"><ion-button (click)="nyomtatasmodal.dismiss()">Bezár</ion-button></ion-buttons>
        <ion-title>Órarend nyomtatása</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="nyomtatasInditas()" [strong]="true">
            <ion-icon slot="start" name="print-outline"></ion-icon>Nyomtatás
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-note color="medium" style="display:block;margin-bottom:12px">
        A most megjelenített hét órái kerülnek egy A4-es fekvő lapra, óra × nap táblázatban, a
        csengetési renddel. A szombat csak akkor kap oszlopot, ha azon a héten van órája.
        Ajtóra kiragasztáshoz a helyettesítéseket érdemes kihagyni.
      </ion-note>
      <ion-list>
        <ion-item>
          <ion-input label="A lap címe" label-placement="stacked" [(ngModel)]="nyomtatas.cim"
                     placeholder="pl. 12-es terem"></ion-input>
        </ion-item>
        <ion-item>
          <ion-toggle [(ngModel)]="nyomtatas.datumMutat">A hét dátuma a lapon</ion-toggle>
        </ion-item>
        <ion-item>
          <ion-toggle [(ngModel)]="nyomtatas.helyettesitesekkel">Helyettesítések feltüntetése</ion-toggle>
        </ion-item>
      </ion-list>
      <ion-note color="medium" style="display:block;margin-top:10px">
        Helyettesítések nélkül a cellákban a tartó tanár neve áll, a tanári lapról pedig
        kimaradnak a más helyett tartott órák.
      </ion-note>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-content [fullscreen]="true">
  <ng-template #userMenu let-user>
    <section class="user-menu">
      <div (click)="variableInfo(user)">Variable Information</div>
      <hr>
      <div (click)="addRecord(user)">Add Record</div>
      <div (click)="editRecord(user)">Edit Record </div>


    </section>
  </ng-template>
  <!-- drag-drop.component.html -->
  <div id="content1">

    <div id="menu" class="row" style="text-align: center;">
      <!--ion-button color="light" disabled>
        <div class="custom-button-content">
          <img src="assets/icon/icons8-verified-account-96.png" width="50px">
          <ion-label>Teszteld</ion-label>
        </div>
      </ion-button>
      <ion-button color="light" disabled>
        <div class="custom-button-content">
          <img src="assets/icon/icons8-siren-96.png" width="50px">
          <ion-label>Generálás</ion-label>
        </div>
      </ion-button>
      <ion-button color="light" disabled>
        <div class="custom-button-content">
          <img src="assets/icon/icons8-flow-chart-96.png" width="50px">
          <ion-label>Korlátozások</ion-label>
        </div>
      </ion-button>
      <span style="margin:5px;border-left:2px solid #bbb;"></span-->
      <!--ion-button color="light" (click)="openComponent('tanar')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-employee-96.png" width="50px">
          <ion-label>Állomány</ion-label>
        </div>
      </ion-button>
      <ion-button color="light" (click)="openComponent('tanterem')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-door-96.png" width="50px">
          <ion-label>Tantermek</ion-label>
        </div>
      </ion-button>
      <ion-button color="light" (click)="openComponent('tantargy')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-copybook-96.png" width="50px">
          <ion-label>Tantárgyak</ion-label>
        </div>
      </ion-button>
      <ion-button color="light" (click)="openComponent('osztaly')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-class-96.png" width="50px">
          <ion-label>Osztályok</ion-label>
        </div>
      </ion-button-->
      <!--ion-button color="light" (click)="openComponent('tanmenet')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-product-documents-96.png" width="50px">
          <ion-label>Tanmenetek</ion-label>
        </div>
      </ion-button-->
      <!--span style="margin:5px;border-left:2px solid #bbb;"></span>
      <ion-button color="light" (click)="openComponent('iskola')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-school-96.png" width="50px">
          <ion-label>Iskola</ion-label>
        </div>
      </ion-button-->
      <ion-button [color]="orarenduzemmod=='admin' ? 'primary':'light'" (click)="changeOrarendUzemmod('admin')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-edit-96.png" width="50px">
          <ion-label>Szerkesztés</ion-label>
        </div>
      </ion-button>
      <ion-button [color]="orarenduzemmod=='torles' ? 'primary':'light'" (click)="changeOrarendUzemmod('torles')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-delete-96.png" width="50px">
          <ion-label>&nbsp;&nbsp;Törlés&nbsp;&nbsp;</ion-label>
        </div>
      </ion-button>
      <ion-button [color]="orarenduzemmod=='helyettesites' ? 'primary':'light'"
        (click)="changeOrarendUzemmod('helyettesites')">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-replace-96.png" width="50px">
          <ion-label>Helyettesítés</ion-label>
        </div>
      </ion-button>
      <span style="margin:5px;border-left:2px solid #bbb;"></span>
      <ion-button color="light">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-vision-96.png" width="50px">
          <span>Nézet:
            <select name="nezet" [(ngModel)]="nezet" (change)="changeMainNezet()">
              <option value="1">Osztály</option>
              <option value="2">Tanár</option>
              <option value="3">Tanterem</option>
              <option value="4">Tantárgy</option>
            </select>
          </span>
        </div>
      </ion-button>
      <ion-button color="light" (click)="nyomtatasMegnyit()" title="A megjelenített hét órarendjének nyomtatása (pl. a terem ajtajára)">
        <div class="custom-button-content">
          <ion-icon name="print-outline" style="font-size:50px;color:var(--ion-color-dark)"></ion-icon>
          <ion-label>Nyomtatás</ion-label>
        </div>
      </ion-button>
      <ion-button color="light" *ngIf="sajatIntezmeny.o_het > 1">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-calendar-96.png" width="50px">
          <span>Hét:
            <select name="het" [(ngModel)]="het">
              <option *ngFor="let it of [].constructor(sajatIntezmeny.o_het); let n = index" [value]="n">{{hetek[n]}}
              </option>
            </select>
          </span>
        </div>
      </ion-button>
    </div>



    <div id="cardSlots" style="background-color: white;">




      <!--ion-card color="danger">
    <ion-card-header color="danger">
      <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Fejlesztés alatt!</ion-card-title>
      <ion-card-subtitle>A menü jelenleg csak helyettesítés rögzítésére alkalmas!</ion-card-subtitle>
    </ion-card-header>
  </ion-card-->

      <ion-grid *ngIf="cal && osztaly && allomany">
        <ion-row>
          <ion-col *ngIf="nezet==2">
            <ng-select (change)="kivalaszt('tanar',$event)" appendTo="body" [notFoundText]="'Nincs találat'"
              [items]="allomany" placeholder="Állomány" bindValue="adid" [multiple]="false" [closeOnSelect]="true"
              bindLabel="full_name">
              <ng-template ng-option-tmp let-item="item">
                <app-profilkep class="nevsor-kep" tipus="dolgozo" [azon]="item.adid" [nev]="item.full_name" [meret]="22"></app-profilkep>{{ item.full_name }}
              </ng-template>
            </ng-select>
          </ion-col>
          <ion-col *ngIf="nezet==1">
            <ng-select (change)="kivalaszt('osztaly',$event)" appendTo="body" [notFoundText]="'Nincs találat'"
              [items]="osztaly" placeholder="Osztály" bindValue="id" [multiple]="false" [closeOnSelect]="true"
              bindLabel="osztaly">
            </ng-select>
          </ion-col>
          <ion-col *ngIf="nezet==3">
            <ng-select (change)="kivalaszt('terem',$event)" appendTo="body" [notFoundText]="'Nincs találat'"
              [items]="terem" placeholder="Tanterem" bindValue="id" [multiple]="false" [closeOnSelect]="true"
              bindLabel="name">
            </ng-select>
          </ion-col>
          <ion-col *ngIf="nezet==4">
            <ng-select (change)="kivalaszt('tantargy',$event)" appendTo="body" [notFoundText]="'Nincs találat'"
              [items]="tantargy" placeholder="Tantárgy" bindValue="id" [multiple]="false" [closeOnSelect]="true"
              bindLabel="name">
            </ng-select>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="orarenduzemmod=='torles'">
          <ion-col>
            <ion-select interface="popover" placeholder="" label="Időtartam"
              label-placement="stacked" fill="outline" [(ngModel)]="torlesmod">
              <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
              <ion-select-option value="O">Teljes tanév</ion-select-option>
              <ion-select-option value="I">I. Félév</ion-select-option>
              <ion-select-option value="II">II. Félév</ion-select-option>
              <ion-select-option value="A">Ettől a héttől</ion-select-option>
              <ion-select-option value="B">Eddig a hétig</ion-select-option>
              <ion-select-option value="C">Csak ez az óra</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col>

            <ion-button class="fc-button" color="danger" (click)="torlesOrarend()">Törlés
              véglegesítése</ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <div class="fc-button-group">
              <ion-button class="fc-button" (click)="prev()"><ion-icon name="arrow-back"></ion-icon></ion-button>
              <ion-button class="fc-button" (click)="next()"><ion-icon name="arrow-forward"></ion-icon></ion-button>
            </div>
            <ion-button class="fc-button" (click)="today()">ma</ion-button>

          </ion-col><ion-col>
            <h2>{{ headerTitle }}</h2>
          </ion-col><ion-col>

            <ion-button class="fc-button" (click)="changeView('workWeek')">Munkahét</ion-button>
            <ion-button class="fc-button" (click)="changeView('workWeekSat')">Munkahét szombattal</ion-button>
            <ion-button class="fc-button" (click)="changeView('timeGridWeek')">Hét</ion-button>
            <!--ion-button class="fc-button" (click)="changeView('timeGridDay')">Nap</ion-button-->

          </ion-col>

        </ion-row>
      </ion-grid>
      <full-calendar #cal [options]="calendarOptions" [deepChangeDetection]="true"></full-calendar>

    </div>


  </div>
  <ion-modal class="nagy" style="z-index: 1000" #orarendmodal id="orarendmodal">
    <ng-template>
      <ion-header [translucent]="true">
        <ion-toolbar color="primary">
          <ion-buttons slot="end">

            <!--ion-button (click)="orarendmodal.dismiss(2)" role="saved" style="background: white; border-radius: 5px" [strong]="true" shape="round"
            color="danger">Törlés</ion-button-->
            <ion-button [disabled]="!formo.valid" (click)="orarendmodal.dismiss(1)" role="saved"
              style="background: white; border-radius: 5px" [strong]="true" shape="round"
              color="secondary">Mentés</ion-button>
          </ion-buttons>
          <ion-buttons slot="start">
            <ion-button (click)="orarendmodal.dismiss()" [strong]="true" shape="round" color="dark"
              style="background: white; border-radius: 5px">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Órarend</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <form [formGroup]="formo">
          <ion-col>
            <ion-card>
              <ion-card-header>
                <ion-card-title>Alapadatok</ion-card-title>
              </ion-card-header>
              <ion-card-content style="margin:5px">

                <ion-row>
                  <ion-col>
                    <div class="input-button-container">
                      <div style="color:black"
                        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                          <div class="input-outline-container sc-ion-input-md">
                            <div class="input-outline-start sc-ion-input-md"></div>
                            <div class="input-outline-notch sc-ion-input-md">
                              <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Állomány</div>
                            </div>
                            <div class="input-outline-end sc-ion-input-md"></div>
                          </div>
                          <div class="label-text-wrapper sc-ion-input-md">
                            <div class="label-text sc-ion-input-md">Állomány</div>
                          </div>
                          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                            <ion-icon name="globe" aria-hidden="true"></ion-icon>
                            <ng-select appendTo="body" [notFoundText]="'Nincs találat'" [items]="allomanyKi"
                              bindValue="adid" [multiple]="true" [closeOnSelect]="true" formControlName="selectedUser"
                              bindLabel="full_name">
                              <ng-template ng-option-tmp let-item="item">
                                <app-profilkep class="nevsor-kep" tipus="dolgozo" [azon]="item.adid" [nev]="item.full_name" [meret]="22"></app-profilkep>{{ item.full_name }}
                              </ng-template>

                            </ng-select>
                          </div>
                        </label>
                      </div>
                    </div>
                  </ion-col>
                </ion-row><ion-row>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Osztály / Csoport" formControlName="osztaly"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option *ngFor="let o of osztaly" [value]="o.id">{{o.osztaly}}</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Hetirend" formControlName="hetirend"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="O">Minden héten</ion-select-option>
                      <!--ion-select-option value="A">A héten</ion-select-option>
                      <ion-select-option value="B">B héten</ion-select-option-->
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Időtartam" formControlName="ido"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="O">Teljes tanév</ion-select-option>
                      <ion-select-option value="I">I. Félév</ion-select-option>
                      <ion-select-option value="II">II. Félév</ion-select-option>
                      <ion-select-option value="A">Ettől a héttől</ion-select-option>
                      <ion-select-option value="B">Eddig a hétig</ion-select-option>
                      <ion-select-option value="C">Csak ez az óra</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <!--ion-col>
                    <ion-input label="Árfolyam" label-placement="stacked" fill="outline" placeholder=""
                      formControlName="arfolyam"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col-->
                </ion-row><ion-row>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Tantárgy" formControlName="tantargy"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option *ngFor="let t of tantargy" [value]="t.id">{{t.name}}</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <!--  Csoportválasztáskor a TANTÁRGY magától beáll: egy bontott csoporthoz
                          jellemzően egy tantárgy tartozik, és ezt az adat is tudja.  -->
                    <ion-select interface="popover" placeholder="Teljes osztály" label="Csoport (opcionális)"
                      formControlName="csoport" label-placement="stacked" fill="outline"
                      (ionChange)="csoportValt($event)">
                      <ion-icon slot="start" name="people" aria-hidden="true"></ion-icon>
                      <ion-select-option [value]="null">— Teljes osztály —</ion-select-option>
                      <ion-select-option *ngFor="let c of csoportok" [value]="c.id">{{c.name}}</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Tanterem" formControlName="tanterem"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option *ngFor="let t of terem" [value]="t.id">{{t.name}}</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-input label="Hossz" label-placement="stacked" fill="outline" placeholder="" type="number"
                      formControlName="hossz"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col>
                  <!-- Tömeges rögzítés: hány egymást követő órahelyre kerüljön ugyanez.
                       Csak ÚJ óránál látszik - meglévőn nincs értelme darabszámot kérni. -->
                  <ion-col *ngIf="ujOra">
                    <ion-input label="Darab" label-placement="stacked" fill="outline" type="number"
                      min="1" max="12" formControlName="darab"
                      helperText="Egymás utáni órahelyek">
                      <ion-icon slot="start" name="copy" aria-hidden="true"></ion-icon>
                    </ion-input>
                  </ion-col>
                </ion-row>
                <!--  Kötött túlóra: az „Időtartam” hatókörére érvényes (pl. „Teljes tanév” =
                      a tanév összes ilyen órája), a már naplózott órákra is. -->
                <ion-row>
                  <ion-col>
                    <ion-checkbox formControlName="tulora" labelPlacement="end">
                      Kötött túlóra
                    </ion-checkbox>
                    <ion-note color="medium" class="tulora-sugo">
                      Az „Időtartam” szerinti órákra érvényes, a már naplózottakra is. A munkaidő-elszámolásban
                      túlóraként jelenik meg.
                    </ion-note>
                  </ion-col>
                </ion-row>

              </ion-card-content>
            </ion-card>
          </ion-col>


          <ion-col>
            <ion-card>
              <ion-card-header>
                <ion-card-title>Tanóra órarendi adatai</ion-card-title>
              </ion-card-header>
              <ion-card-content style="margin:5px">
                <ion-row>
                  <ion-col>
                    <ion-input label="Tanóra kezdődátuma" label-placement="stacked" fill="outline" placeholder=""
                      [readonly]="true" type="date" max="3000-12-31" formControlName="erv_kezd"><ion-icon slot="start"
                        name="time" aria-hidden="true"></ion-icon></ion-input><br>

                    <ion-modal [keepContentsMounted]="true">
                      <ng-template>
                        <ion-datetime style="border: 1px solid;" id="datetime" [firstDayOfWeek]="1" presentation="date"
                          [formatOptions]="{
                  date: {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                  },
                }"></ion-datetime>
                      </ng-template>
                    </ion-modal>
                  </ion-col>
                  <ion-col>
                    <ion-input [readonly]="true" label="Órarendi nap" label-placement="stacked" fill="outline"
                      placeholder="" formControlName="nap"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col>
                  <ion-col>
                    <ion-input [readonly]="true" label="Órarendi nap" label-placement="stacked" fill="outline"
                      placeholder="" formControlName="napszam"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col>
                  <ion-col>
                    <ion-input [readonly]="true" label="Hányadik óra?" label-placement="stacked" fill="outline"
                      placeholder="" formControlName="ora"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col>
                </ion-row>
                <ion-row>

                </ion-row>
              </ion-card-content>
            </ion-card>
          </ion-col>


          <!--ion-col>
            <ion-card>
              <ion-card-header>
                <ion-card-title>Órarendi napra vonatkozó adatok</ion-card-title>
              </ion-card-header>
              <ion-card-content style="margin:5px">
                <ion-col>
                  <ion-select interface="popover" placeholder="" label="Csengetési rend" formControlName="csengetes"
                    label-placement="stacked" fill="outline">
                    <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                    <ion-select-option *ngFor="let t of terem" [value]="t.id">{{t.name}}</ion-select-option>
                  </ion-select>
                </ion-col>
              </ion-card-content>
            </ion-card>
          </ion-col-->


        </form>
      </ion-content>
    </ng-template>
  </ion-modal>

  <ion-modal class="nagy1" style="z-index: 1000" #helyettesitesmodal id="helyettesitesmodal">
    <ng-template>
      <ion-header [translucent]="true">
        <ion-toolbar color="primary">
          <ion-buttons slot="end">
            <!-- ELMARADT: önálló állapot, nem helyettesítési mód (2026-10-15) – külön gomb, helyettesítő nélkül. -->
            <ion-button *ngIf="!helyettesitettOraElmaradt" (click)="helyettesitesmodal.dismiss(3)" role="saved"
              style="background: white;border-radius: 5px" [strong]="true" shape="round"
              color="medium">Elmaradt</ion-button>
            <ion-button *ngIf="helyettesitettOraElmaradt" (click)="helyettesitesmodal.dismiss(4)" role="saved"
              style="background: white;border-radius: 5px" [strong]="true" shape="round"
              color="medium">Mégis megtartva</ion-button>
            <ion-button [disabled]="!formh.valid" (click)="helyettesitesmodal.dismiss(2)" role="saved"
              style="background: white;border-radius: 5px" [strong]="true" shape="round"
              color="danger">Törlés</ion-button>
            <ion-button [disabled]="!formh.valid" (click)="helyettesitesmodal.dismiss(1)" role="saved"
              style="background: white; border-radius: 5px" [strong]="true" shape="round"
              color="secondary">Mentés</ion-button>
          </ion-buttons>
          <ion-buttons slot="start">
            <ion-button (click)="helyettesitesmodal.dismiss()" [strong]="true" shape="round" color="dark"
              style="background: white; border-radius: 5px">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Helyettesítés<ng-container *ngIf="helyettesitettOraFejlec"> – {{ helyettesitettOraFejlec.idopont }}</ng-container></ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <form [formGroup]="formh">
          <ion-col>
            <ion-card *ngIf="helyettesitettOraFejlec" class="helyettesitett-ora">
              <ion-card-header>
                <ion-card-subtitle>Helyettesítendő óra</ion-card-subtitle>
                <ion-card-title>{{ helyettesitettOraFejlec.idopont }}</ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <div class="ho-sor">
                  <span><b>Osztály / csoport:</b> {{ helyettesitettOraFejlec.cel || '–' }}</span>
                  <span><b>Tantárgy:</b> {{ helyettesitettOraFejlec.tantargy || '–' }}</span>
                  <span *ngIf="helyettesitettOraFejlec.tarto"><b>Tartó tanár:</b> {{ helyettesitettOraFejlec.tarto }}</span>
                  <span *ngIf="helyettesitettOraFejlec.terem"><b>Terem:</b> {{ helyettesitettOraFejlec.terem }}</span>
                </div>
              </ion-card-content>
            </ion-card>
            <ion-card>
              <ion-card-header>
                <ion-card-title>Alapadatok</ion-card-title>
              </ion-card-header>
              <ion-card-content style="margin:5px">

                <ion-row>
                  <ion-col>
                    <ion-input [readonly]="true" label="Hányadik óra?" label-placement="stacked" fill="outline"
                      placeholder="" style="display:none"></ion-input>
                    <div class="input-button-container">
                      <div style="color:black"
                        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                          <div class="input-outline-container sc-ion-input-md">
                            <div class="input-outline-start sc-ion-input-md"></div>
                            <div class="input-outline-notch sc-ion-input-md">
                              <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Helyettesítő</div>
                            </div>
                            <div class="input-outline-end sc-ion-input-md"></div>
                          </div>
                          <div class="label-text-wrapper sc-ion-input-md">
                            <div class="label-text sc-ion-input-md">Helyettesítő</div>
                          </div>
                          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                            <ion-icon name="globe" aria-hidden="true"></ion-icon>
                            <ng-select appendTo="body" [notFoundText]="'Nincs találat'" [items]="helyettesitoLista"
                              bindValue="adid" [multiple]="false" [closeOnSelect]="true" formControlName="selectedUser"
                              bindLabel="full_name" groupBy="csoport" class="helyettesito-valaszto"
                              [placeholder]="helyettesitoJeloltek ? 'Keresés névre – a szabad kollégák elöl' : 'Helyettesítő'">
                              <ng-template ng-optgroup-tmp let-item="item">
                                <span class="hj-csoport">{{ item.csoport }}</span>
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item">
                                <div class="hj-sor">
                                  <app-profilkep class="nevsor-kep" tipus="dolgozo" [azon]="item.adid" [nev]="item.full_name" [meret]="24"></app-profilkep>
                                  <span class="hj-nev">{{ item.full_name }}</span>
                                  <span class="hj-cimkek">
                                    <span *ngFor="let c of item.cimkek" class="hj-cimke" [class.hj-jo]="c.tipus === 'jo'"
                                          [class.hj-foglalt]="c.tipus === 'foglalt'">{{ c.szoveg }}</span>
                                  </span>
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </label>
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="helyettesitettOraElmaradt">
                  <ion-col>
                    <ion-note color="medium" class="hj-magyarazat">
                      Ez az óra elmaradtként áll{{ helyettesitettOraElmaradtOk ? ' (' + helyettesitettOraElmaradtOk + ')' : '' }}.
                      Helyettesítő kiírásával a jelölés lekerül – akkor valaki megtartotta.
                    </ion-note>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="helyettesitoJeloltek && formh.getRawValue().mod !== 'E'">
                  <ion-col>
                    <ion-checkbox [(ngModel)]="helyettesitoMindenki" [ngModelOptions]="{standalone: true}"
                                  (ionChange)="helyettesitoListaEpit()" labelPlacement="end">
                      Mindenki látszódjon (a foglaltak és az órarend nélküliek is)
                    </ion-checkbox>
                    <ion-note color="medium" class="hj-magyarazat">
                      Elöl azok, akik ebben az órában szabadok és aznap amúgy is bent vannak – közülük is
                      a lyukasórások, a szaktanárok, az osztályt tanítók és a hét során kevesebbet helyettesítők.
                      Összevonásnál a foglalt, épp órát tartó kollégák kerülnek előre.
                    </ion-note>
                  </ion-col>
                </ion-row><ion-row>
                  <!--ion-col>
                    <ion-select interface="popover" placeholder="" label="Időtartam" formControlName="ido"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="O">Teljes tanév</ion-select-option>
                      <ion-select-option value="I">I. Félév</ion-select-option>
                      <ion-select-option value="II">II. Félév</ion-select-option>
                      <ion-select-option value="A">Ettől a héttől</ion-select-option>
                      <ion-select-option value="B">Eddig a hétig</ion-select-option>
                      <ion-select-option value="C">Csak ez az óra</ion-select-option>
                    </ion-select>
                  </ion-col-->
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Módja" formControlName="mod"
                      label-placement="stacked" fill="outline" (ionChange)="helyettesitesModValt()">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="H">Helyettesítés / Felügyelet</ion-select-option>
                      <ion-select-option value="O">Összevonás</ion-select-option>
                      <!-- Az „Elmaradt” már nem helyettesítési mód: külön gomb a fejlécben (2026-10-15). -->
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Típus" formControlName="tipus"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="E">Eseti</ion-select-option>
                      <ion-select-option value="T">Tartós</ion-select-option>
                      <ion-select-option value="S">Szívességi</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <!--ion-col>
                    <ion-input label="Árfolyam" label-placement="stacked" fill="outline" placeholder=""
                      formControlName="arfolyam"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col-->
                </ion-row>

              </ion-card-content>
            </ion-card>
          </ion-col>


        </form>
      </ion-content>
    </ng-template>
  </ion-modal>

  <ion-modal (willDismiss)="onWillDismiss($event)" [style.--height]="'250px'">
    <ng-template>
      <ion-header>
        <ion-toolbar [style.--background]="kivalasztottora.szin" [style.color]="'white'">
          <!--ion-buttons slot="start">
          <ion-button (click)="cancel()">Bezár</ion-button>
        </ion-buttons-->
          <ion-title>Tanóra: {{kivalasztottora.evfolyam.osztaly}} {{kivalasztottora.rovid ?? kivalasztottora.nev}} -
            {{allomany[kivalasztottora.ttfel.munkatars].intezmenyadatok.kod ??
            allomany[kivalasztottora.ttfel.munkatars].oktazon}} ({{kivalasztottora.orarend.hossz}}db)</ion-title>
          <ion-buttons slot="end">
            <ion-button style="background: white;border-radius: 5px;" (click)="cancel()" [strong]="true"
              [disabled]="validateForm()" shape="round" [style.color]="kivalasztottora.szin">Bezár</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin:auto;text-align: center;">
        <ion-button size="large" [style.--background]="kivalasztottora.szin">
          Óra módosítása
          <ion-icon slot="start" name="create"></ion-icon>
        </ion-button>
        <ion-button size="large" color="warning" *ngIf="kivalasztottora.orarend?.locked != 1">
          Lezárás
          <ion-icon slot="start" name="lock-closed"></ion-icon>
        </ion-button>
        <ion-button size="large" color="dark" *ngIf="kivalasztottora.orarend?.locked == 1">
          Feloldás
          <ion-icon slot="start" name="lock-open"></ion-icon>
        </ion-button>
        <ion-button size="large" color="danger" (click)="delOrarend()"
          [disabled]="kivalasztottora.orarend?.locked == 1">
          Törlés
          <ion-icon slot="start" name="trash"></ion-icon>
        </ion-button>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>